import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { competitionOptions } from '@/module/Nomen/Competition/model/CompetitionModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type CompetitionSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function CompetitionSelectControl<T extends FieldValues>(props: CompetitionSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(competitionOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
